function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 4C2.22386 4 2 4.22386 2 4.5V11.8038V17.5V21.1017C2 21.5301 2.5035 21.7601 2.82733 21.4797L6.70438 18.122C6.79527 18.0433 6.91148 18 7.03171 18H21.5C21.7761 18 22 17.7761 22 17.5V4.5C22 4.22386 21.7761 4 21.5 4H2.5Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.70438 18.122L5.7224 16.9881L6.70438 18.122ZM2.82733 21.4797L1.84535 20.3458L2.82733 21.4797ZM3.5 4.5C3.5 5.05229 3.05228 5.5 2.5 5.5V2.5C1.39543 2.5 0.5 3.39543 0.5 4.5H3.5ZM3.5 11.8038V4.5H0.5V11.8038H3.5ZM3.5 17.5V11.8038H0.5V17.5H3.5ZM3.5 21.1017V17.5H0.5V21.1017H3.5ZM5.7224 16.9881L1.84535 20.3458L3.80931 22.6136L7.68637 19.2559L5.7224 16.9881ZM21.5 16.5H7.03171V19.5H21.5V16.5ZM20.5 17.5C20.5 16.9477 20.9477 16.5 21.5 16.5V19.5C22.6046 19.5 23.5 18.6046 23.5 17.5H20.5ZM20.5 4.5V17.5H23.5V4.5H20.5ZM21.5 5.5C20.9477 5.5 20.5 5.05228 20.5 4.5H23.5C23.5 3.39543 22.6046 2.5 21.5 2.5V5.5ZM2.5 5.5H21.5V2.5H2.5V5.5ZM7.68637 19.2559C7.50459 19.4134 7.27218 19.5 7.03171 19.5V16.5C6.55078 16.5 6.08596 16.6733 5.7224 16.9881L7.68637 19.2559ZM0.5 21.1017C0.5 22.8152 2.51402 23.7353 3.80931 22.6136L1.84535 20.3458C2.49299 19.7849 3.5 20.2449 3.5 21.1017H0.5Z",
  fill: "#98A7B8",
  mask: "url(#path-1-inside-1)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 8,
  width: 11,
  height: 1.5,
  rx: 0.5,
  fill: "#98A7B8"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 12,
  width: 6,
  height: 1.5,
  rx: 0.5,
  fill: "#98A7B8"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 4,
  r: 4,
  fill: "#DE106B"
});

function SvgChatNewMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNewMessage);
export default __webpack_public_path__ + "static/media/chat-new-message.5b52dd77.svg";
export { ForwardRef as ReactComponent };